import { Page } from './types'
import Hint from '../components/Hint'
import Screenshot, { ScreenshotRef } from '../components/Screenshot'

const render = () => (
    <div className="row">
        <div className="col-8">
            <ul>
                <li>Login on the Gurobi website <ScreenshotRef label="1"/></li>
                <li>At the top, click <i>Downloads &amp; Licenses</i> and then <i>Your Gurobi Licenses</i> <ScreenshotRef label="2"/></li>
                <li>Scroll to the WLS license you want to use</li>
                <li>On the right side in this table row, click <i>Open</i> <ScreenshotRef label="3"/>; you are redirected to the Web License Manager</li>
                <li>At the bottom of the box containing your license details, click <i>Download</i> <ScreenshotRef label="4"/></li>
                <li>Confirm that you want to generate a new API key.</li>
                <li>Enter a name and description for your application and click <i>Create</i>.</li>
                <li>Then click <i>Download</i>. Feel free to open the file in a text editor to see its content.</li>
                <li>We will refer to this file as your <i>WLS license file</i> or simply <code>gurobi.lic</code> later in this guide.</li>
            </ul>
            <Hint>
                API keys are used to track usage of your license. By issuing separate API keys for individual developers and products, you
                will be able to see the usage per API key. This approach is also safer since it allows you to revoke access from specific developers
                by disabling or deleting their API key.
            </Hint>
        </div>
        <aside className="screenshots col-4">
            <Screenshot label="1" src="01-login.png"/>            
            <Screenshot label="2" src="02-find-licenses.png"/>
            <Screenshot label="3" src="06-open-wls.png"/>
            <Screenshot label="4" src="11-download-wls.png"/>
        </aside>
    </div>
)

const DownloadWLSLicenseFile : Page<{}> = { key: 'download-wls-license', title: 'Download a WLS license file', render }

export default DownloadWLSLicenseFile